import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../shared/components/RouteError";
import { RoutePending } from "../shared/components/RoutePending";

/**
 * @purpose Finish an invited account (set password/profile)
 * @primary Registration form
 * @persona all
 */
export const Route = createFileRoute("/_public/complete-registration")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
